import { PartnerContextProps } from './types/debts-payload';

const RLPayloadCreator = {
  EventsDebtsContext(props: {
    debt: any;
    paymentOption: any;
    agreement?: any;
    customPaymentMethod?: string;
    selectedPaymentDate?: string;
    isExternalPix?: boolean;
  }) {
    const { debt, paymentOption, agreement, customPaymentMethod, selectedPaymentDate } = props;

    return {
      correlationId: RLPayloadCreator.createCorrelationId(debt, agreement),
      partnerContext: RLPayloadCreator.partnerContext({ debt, agreement }),
      debtContext: RLPayloadCreator.debtContext(debt, paymentOption),
      ...(agreement && {
        agreementContext: RLPayloadCreator.agreementContext(agreement, paymentOption, customPaymentMethod, selectedPaymentDate),
      }),
    };
  },

  createCorrelationId(debt: any, agreement?: any) {
    return `${debt?.id}|${debt?.partner?.partnerIdentifier || debt?.partnerIdentifier || agreement?.partner?.identificador}`;
  },

  partnerContext({ debt, agreement, partnerSystem }: PartnerContextProps) {
    const partnerId = partnerSystem?.id || debt?.partner?.id || agreement?.partnerSystem.id;
    const partnerIdentifier = partnerSystem?.partnerIdentifier || debt?.partner?.partnerIdentifier || agreement?.partner?.identificador;
    const identifier = partnerSystem?.identifier || debt?.partner?.identifier || agreement?.partnerSystem?.identificador;

    return {
      partnerId,
      partnerIdentifier,
      identifier,
    };
  },

  debtContext(debt: any, paymentOption: any) {
    const splittedDateHour = (date: any) => date?.split('T')?.[0];

    const originalDate = splittedDateHour(debt?.detalhes?.[0]?.dataOriginalDivida) || splittedDateHour(debt?.details?.[0]?.originalDebtDate);

    const maxInstallments = debt?.maxNumberInstallment || debt?.opcaoPagamento?.[debt?.opcaoPagamento?.length - 1]?.qtdParcela || 0;
    const agreementValue = paymentOption?.valorAcordo || paymentOption?.agreementValue;
    const isDebtNegative = debt?.negativeStatus === 'SCPC' || debt?.negativeStatus === 'BOTH' || debt?.negativeStatus === 'PARTNER';

    return {
      debtId: Number(debt?.id),
      isNegative: isDebtNegative,
      negativeStatus: debt?.negativeStatus || 'NONE',
      agreementValue,
      originalValue: debt?.valor || paymentOption?.originalDebtValue,
      currentValue: debt?.valorDivida || paymentOption?.currentDebtValue,
      ...(debt?.valorMinimo && { minimalValue: debt?.valorMinimo }),
      discountPercentage: paymentOption?.percentualDesconto || paymentOption?.discountPercentage || 0,
      totalInstallments: paymentOption?.qtdParcela || paymentOption?.numberInstallment,
      originalCompany: debt?.origem || debt?.source,
      product: debt?.produto || debt?.product,
      contract: debt?.contrato || debt?.contract,
      identifier: debt?.identificador || debt?.identifier,
      isLeadRedirect: debt?.partner?.isLeadRedirect,
      originalDebtDate: originalDate,
      maxNumberInstallment: maxInstallments,
      propensityToAccept: debt?.propensityToAccept,
      ...(debt?.dataSimulacao && { simulationDate: debt?.dataSimulacao }),
      ...(debt?.tagDiscountDropValue > 1 && { tagDiscountDropValue: debt?.tagDiscountDropValue }),
      ...(debt?.tagName && { tagName: debt?.tagName }),
      ...(debt?.typeSelected && { negotiationType: debt?.typeSelected }),
    };
  },

  agreementContext: (agreement: any, paymentOption: any, customPaymentMethod?: string, selectedPaymentDate?: string) => {
    return {
      paymentMethod: customPaymentMethod || paymentOption?.paymentMethodName,
      agreementId: agreement?.id,
      paymentOptionId: paymentOption?.id,
      agreementValue: paymentOption?.valorAcordo,
      numberOfInstallments: paymentOption?.qtdParcela,
      installmentValue: paymentOption?.valorParcela,
      entryValue: paymentOption?.valorEntrada,
      ...(selectedPaymentDate && { selectedPaymentDate: selectedPaymentDate }),
    };
  },
};

export default RLPayloadCreator;
